module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/node_modules/core-js/internals/is-pure.js
// module id = rjoJ
// module chunks = 0